var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.footer'] = (function () {
    'use strict';

    const CONFIG = {
        CARD_SELECTOR: '.footer-links .card',
        CARD_ANIMATION: 'animate__fadeInUp',
        CARD_STAGGER: 150
    };

    const initialize = (block) => {
        if (!block || !block.id) return;

        if (block.querySelectorAll(CONFIG.CARD_SELECTOR).length === 0) return;

        App.ZagScrollAnimate.initialize(`#${CSS.escape(block.id)}`, {
            offset: 90,
            targets: [
                { selector: CONFIG.CARD_SELECTOR, type: CONFIG.CARD_ANIMATION, stagger: CONFIG.CARD_STAGGER }
            ]
        });
    };

    return {
        initialize
    };

})();
